import { inject } from '@angular/core';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';
import { Router } from '@angular/router';
import { LoggingService } from '../logging/logging.service';

export const ShopFeatureGuard = () => {
    const router = inject(Router);
    const splashScreenStateService = inject(SplashScreenStateService);
    const log = inject(LoggingService).getLogger(ShopFeatureGuard.name);
    const configService = inject(ConfigService);

    if (configService.config()?.configuration.features?.catalog?.enabled) {
        splashScreenStateService.stop();
        return true;
    } else {
        log.info("Feature catalog isn't enable");
        return router.navigate(['/']);
    }
};
